import React from "react";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/styles";
import {
  SortingState,
  SelectionState,
  FilteringState,
  GroupingState,
  IntegratedFiltering,
  IntegratedGrouping,
  IntegratedSelection,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  TableHeaderRow,
  TableFilterRow,
  TableGroupRow,
} from "@devexpress/dx-react-grid-material-ui";

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word",
  },
};

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
);

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0,
    }}
    {...restProps}
  />
);

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class TechSpecGrid extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "category", title: "Kategorie" },
        { name: "feature", title: "Feature" },
        { name: "property", title: "Eigenschaft" },
      ],
      rows: [
        {
          category: "Optik & Bildgebung",
          feature: "Standard Objektiv",
          property: "f = 2,7mm - 13.5mm; F/1.6 (Wide) - F/2.95 (Tele)",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Blickwinkel",
          property: "30 - 130° Diagonal",
        },
        {
          category: "Optik & Bildgebung",
          feature: "CMOS Sensor",
          property: "Sony STARVIS IMX415 CMOS Sensor [2]",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Sensor Format",
          property: '1/2.8"',
        },
        {
          category: "Optik & Bildgebung",
          feature: "Abmessungen",
          property: "Diagonal 6.4 mm",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Pixel Größe",
          property: "1.45 μm (H) × 1.45 μm (V)",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Dynamischer Bereich",
          property: "30 dB",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Empfindlichkeit",
          property: ">=2000mV",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Max. Auflösung",
          property: "8.29 Megapixel",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Gesamtpixelanzahl",
          property: "3864 (H) × 2228 (V) approx. 8.60 M pixels",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Anzahl an effektiven Pixeln",
          property: "3864 (H) × 2192 (V) approx. 8.46 M pixels",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Anzahl an aktiven Pixeln",
          property: "3864 (H) × 2176 (V) approx. 8.40 M pixels",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Anzahl empfohlener Pixeln",
          property: "3840 (H) × 2160 (V) approx. 8.29 M pixels",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Unterstützte Auflösungen",
          property:
            "2160p (3840x2160 Pixel ~ 8.29MP), 1080p (1920x1080 Pixel ~ 2.1MP), 720p (1280x720 Pixel ~ 1MP))",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Bit Tiefe",
          property: "10 / 12 bit",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Hoher Dynamikbereich (HDR)",
          property: "Mehrfachbelichtung HDR / Digitale Überlagerung HDR",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Video Komprimierung",
          property: "h.265, h.264, MJPEG, JPG",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Bitrate (h.265)",
          property: "bis zu 5.120 kbps",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Framerate",
          property: "4K @30fps",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Parallele Streams",
          property: "3",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Video Overlay",
          property: "Datum, Zeit, Kamera Name",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Video Parameter",
          property:
            "Helligkeit, Kontrast, Sättigung, Schärfe, Gamma, Belichtung",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Tag/Nacht Schaltung",
          property: "Ja",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Weißabgleich",
          property: "Automatisch",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Elektronischer Shutter",
          property: "Automatisch",
        },
        {
          category: "Optik & Bildgebung",
          feature: "Flip / Spiegel Video",
          property: "Ja / Ja",
        },
        {
          category: "Nachtsicht",
          feature: "Infrarot LEDs",
          property: "6 High-Power LEDs",
        },
        {
          category: "Nachtsicht",
          feature: "Weißlicht LEDs",
          property: "6 High-Power-Flutlicht-LEDs",
        },
        {
          category: "Nachtsicht",
          feature: "IR Modes",
          property: "aus/an/automatisch",
        },
        {
          category: "Nachtsicht",
          feature: "Effektive Reichweite",
          property: "20-30m",
        },
        {
          category: "Nachtsicht",
          feature: "intgr. IRcut Filter",
          property: "Ja (Automatisch)",
        },
        {
          category: "Netzwerk",
          feature: "Netzwerk Protokolle",
          property:
            "TCP/IP, DHCP, PPPoE, ARP, FTP, SMTP, DNS, NTP, UPnP, HTTP, TCP, UDP, MQTTv.5",
        },
        {
          category: "Netzwerk",
          feature: "Übertragungsverschlüsselung",
          property: "TLSv1.3 - HTTPS. MQTTSv.5, FTPS, sFTP",
        },
        {
          category: "Netzwerk",
          feature: "WiFi Verschlüsselung (nicht im PoE Model)",
          property: "WPA2 / WPA3 / Enterprise",
        },
        {
          category: "Netzwerk",
          feature: "WiFi Frequenz (nicht im PoE Model)",
          property: "866 Mbit 5GHz / 2.4GHz, Wi‑Fi 5 (802.11ac)",
        },
        {
          category: "Netzwerk",
          feature: "WiFi Frequenz Bänder (nicht im PoE Model)",
          property: "2,4-2.4845GHz, 5,150-5,350/5,470 - 5,725GHz",
        },
        {
          category: "Netzwerk",
          feature: "WiFi Frequenz Übertragung",
          property: "<16dBm @ 11b/g, <15dBm @ 11n < 18dBm @11ac",
        },
        {
          category: "Netzwerk",
          feature: "WiFi Antenne (nicht im PoE Model)",
          property: "2x 3,5db RP-SMA Antenne [2]",
        },
        {
          category: "Netzwerk",
          feature: "WiFi Reichweite (nicht im PoE Model)",
          property: "ca. 10-15m",
        },
        {
          category: "Netzwerk",
          feature: "kostenlose DDNS Adresse",
          property: "Ja",
        },
        { category: "Netzwerk", feature: "kostenlose P2P UID", property: "Ja" },
        {
          category: "Chipset",
          feature: "AI IPCAM SoC",
          property: "Novatek NT98528",
        },
        { category: "Chipset", feature: "CPU", property: "Dual Cortex A9" },
        { category: "Chipset", feature: "Speicher", property: "16-bit DDR3" },
        { category: "Chipset", feature: "Codec", property: "8Mp20+sub stream" },
        {
          category: "Chipset",
          feature: "Fast Boot",
          property: "Linux application < 1.2/1.5s",
        },
        {
          category: "Chipset",
          feature: "Platform AI",
          property: "HW-CNN 1.5T",
        },
        {
          category: "Chipset",
          feature: "ISP",
          property: "TMNR2 3DNR, SHDR, Defog, RGBIR",
        },
        { category: "Chipset", feature: "Serielller Bus", property: "USB2.0" },
        {
          category: "Features",
          feature: "Bewegungserkennung",
          property: "Ja (Software Analyse + PIR)",
        },
        { category: "Features", feature: "Alarm Eingang", property: "Ja" },
        { category: "Features", feature: "Alarm Ausgang", property: "Ja" },
        {
          category: "Features",
          feature: "PIR Sensor Winkel",
          property: "120° horizontal",
        },
        {
          category: "Features",
          feature: "PIR Reichweite",
          property: "12 Meter",
        },
        {
          category: "Features",
          feature: "Alarm Benachrichtigung",
          property: "Email/FTP/HTTP (Alarmserver)/Push",
        },
        {
          category: "Features",
          feature: "Alarm Pre-Recording",
          property: "Ja (3s)",
        },
        {
          category: "Features",
          feature: "Fotoserie",
          property: "Ja (auf SD Karte und FTP Server)",
        },
        {
          category: "Features",
          feature: "SD Karte",
          property:
            "Erweiterbare microSDHC Karte bis zu 256GB (32GB inklusive)  [3]",
        },
        {
          category: "Features",
          feature: "Cloud Speicherplatz",
          property: "Ja (optional)",
        },
        { category: "Features", feature: "Pan & Tilt", property: "350° / 90°" },
        {
          category: "Features",
          feature: "Mikrofon",
          property: "Integriertes Mikrofon",
        },
        {
          category: "Features",
          feature: "Lautsprecher",
          property: "Integriertes Lautsprecher",
        },
        {
          category: "Features",
          feature: "Intercom",
          property: "Zwei-Wege-Audiokommunikation mit unserer App InstarVision",
        },
        { category: "Features", feature: "Audio-Ausgang", property: "Nein" },
        {
          category: "Features",
          feature: "Scheduled & Alarm Recording",
          property: "Ja",
        },
        {
          category: "Hardware",
          feature: "Gehäuse",
          property: "IP65 Aluminium (weiß/schwarz)",
        },
        {
          category: "Hardware",
          feature: "Halterung",
          property: "Wand & Deckenhalterung",
        },
        {
          category: "Hardware",
          feature: "Betriebstemperatur",
          property: "-20°C bis 55°C (es wird kein extra Heizelement benötig)",
        },
        {
          category: "Hardware",
          feature: "Netzspannung",
          property: "110V - 230V",
        },
        {
          category: "Hardware",
          feature: "Netzwerkkabel",
          property: "3m Cat5e",
        },
        {
          category: "Hardware",
          feature: "Netzteil",
          property:
            "110-240V ac @ 50-60Hz bis 12V dc und 2000mA - Kabellänge: 3m",
        },
        {
          category: "Hardware",
          feature: "Netzstecker",
          property: "2,1mm Innen / 5,5mm Außen",
        },
        {
          category: "Hardware",
          feature: "Power-over-Ethernet",
          property: "PoE IEEE 802.3at",
        },
        {
          category: "Hardware",
          feature: "Stromverbrauch",
          property: "Max. 18W (Normalbetrieb 5W)",
        },
        { category: "Hardware", feature: "Gewicht", property: "1900 g" },
        {
          category: "Hardware",
          feature: "Abmessungen in [cm]",
          property: "23 cm / 15 cm / 15 cm",
        },
        {
          category: "Hardware",
          feature: "Pyroelektrischer Bewegungsmelder",
          property:
            "Panasonic PaPIR EKMC16 Long Distance Pyroelectric Sensor [4]",
        },
        {
          category: "Hardware",
          feature: "PIR Sensor Winkel",
          property: "102° x 92° (108° x 99°)",
        },
        {
          category: "Hardware",
          feature: "PIR Reichweite",
          property: "bis zu 12m [6]",
        },
        { category: "Hardware", feature: "PIR Zonen", property: "92" },
        {
          category: "Hardware",
          feature: "PIR Bedingungen",
          property:
            "Temp Unterschied > 4°C, Objektgeschwindigkeit: 1.0m/s, mit einer Größe von 700×250mm",
        },
        {
          category: "Hardware",
          feature: "Zertifikate",
          property: "CE, FCC, RoHS",
        },
      ],
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{ display: "inline-block", maxWidth: "915px" }}>
        <Grid rows={rows} columns={columns}>
          <FilteringState />

          <SortingState
            defaultSorting={[{ columnName: "category", direction: "asc" }]}
          />
          <GroupingState
            defaultGrouping={[{ columnName: "category" }]}
            defaultExpandedGroups={["Optik & Bildgebung"]}
          />
          <SelectionState />

          <IntegratedFiltering />
          <IntegratedGrouping />
          <IntegratedSelection />
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
          <TableFilterRow />
          <TableGroupRow />
        </Grid>
      </Paper>
    );
  }
}

TechSpecGrid.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TechSpecGrid);
